import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=7bb7ab5e"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports